import { InjectionToken } from '@angular/core';

import type { ClientConfig } from '~ng-common-lib/client-config';

/** Resolved tenant branding/features; use `inject(CLIENT_CONFIG)` or factory deps. */
export const CLIENT_CONFIG = new InjectionToken<ClientConfig>('CLIENT_CONFIG');
